import { useRef, useState, useCallback } from 'react';

const useReveal = () => {
  const [visible, setVisible] = useState(false);
  const observerRef = useRef(null);

  const ref = useCallback((node) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node) {
      observerRef.current = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observerRef.current?.disconnect();
          }
        },
        { threshold: 0 }
      );
      observerRef.current.observe(node);
    }
  }, []);

  return [ref, visible];
};

export default useReveal;